import { useContext } from "react";
import { StorageContextProps, StorageContext } from "@/providers/StorageProvider";

export function useStorage() {
  const context = useContext(StorageContext) as StorageContextProps;

  if (!context) throw new Error("useStorage must be used within a StorageProvider");

  return context;
}
